export enum BoundarySource {
  TomTomPlace,
  KnownBoundary,
  DrawnBoundary,
  UploadedBoundary,
}
